import(/* webpackMode: "eager" */ "/vercel/path0/src/app/counselor/layout.tsx");
